import { useOktaAuth } from "@okta/okta-react";
import { UseQueryResult, useQuery } from "@tanstack/react-query";
import axiosInstance from "../../api";

function useTestOrderSingleID(
  id: string
): UseQueryResult<any> {
  const { authState } = useOktaAuth();

  return useQuery({
    queryKey: ["orderSummary", id],
    queryFn: ({ queryKey }) => {
      const [_key, id] = queryKey;  

      return axiosInstance
        .get(`/v1/orders/new-flow/${id}`, {
          headers: {
            Authorization: `Bearer ${authState?.accessToken?.accessToken}`,
          },
        })
        .then((res) => res.data);
    },
    enabled: !!id && !!authState?.accessToken?.accessToken, // Ensure the query only runs if id is available
  });
}

export default useTestOrderSingleID;
